module.exports = __webpack_public_path__ + "img/bookinfo.e34f38ad.png";